export default "/images/19 Step5KeepItUp-Provider-To retake a self-assessment.png?bd4e0fbfb5de189b4eb5b62a694d06a0";